module.exports = __webpack_public_path__ + "img/left@1x.28930af4.svg";